// cleanup_convert_to_typescript_file_MODIFY_RECURRING_TRANSFERS

import React, { useContext } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { template } from 'lodash';

import Modal, { TYPES } from '@glu/modal-react';
import { FormContext } from '@glu/validation-react';
import { Locale } from '@glu/locale-react';
import gluLocale from '@glu/locale';
import { UseFundsNextIcon } from '@glu/icons-react';

import useLocale from 'components/useLocale';
import { numberToCurrency } from 'utils/currency';
import { DATE_FORMAT } from 'constants.js';

import recurringTransferLocale from './recurringTransfer.locale';
import useStyles from './RecurringTransferDeleteModal.styles';

gluLocale.set(recurringTransferLocale);

export function ConfirmModalComponent({ modify, onCancel, submitDisabled }) {
  const locale = useLocale();
  const form = useContext(FormContext);
  const { modalDialog } = useStyles();
  const { data } = form;

  const header = modify
    ? locale['recurringTransfer.modifyConfirmMessage.header']
    : locale['recurringTransfer.confirmMessage.header'];

  const tmpl = modify
    ? 'recurringTransfer.modifyConfirmMessage'
    : 'recurringTransfer.confirmMessage';

  return (
    <Modal
      btnPrimaryAttributes={{
        name: 'confirm',
        disabled: submitDisabled,
        className: 'btn btn-primary',
        type: 'submit'
      }}
      btnPrimaryText={locale['common.continue']}
      btnTertiaryAttributes={{
        'data-qa': 'modify-payment-confirm-cancel',
        className: 'btn btn-tertiary'
      }}
      btnTertiaryText={locale['common.cancel']}
      classes={{
        card: modalDialog
      }}
      data-qa="send-payment-confirm-modal"
      dataQa="modify-payment-confirm-modal"
      onBtnTertiaryClick={onCancel}
      onClose={onCancel}
      open
      type={TYPES.INFO}
    >
      <div>
        <UseFundsNextIcon />
        <h2 className="modal-header">{header}</h2>
        <p className="modal-text">
          {modify && (
            <strong>
              {template(locale['recurringTransfer.modifyWarning'])({ name: data?.name })}
            </strong>
          )}
        </p>
        <p>
          <Locale
            localeKey={tmpl}
            params={[
              <strong>{locale['recurringTransfer.name']}</strong>,
              <strong>{numberToCurrency(data?.amount)}</strong>,
              <strong>{data?.debitAccount?.[0]?.shortName}</strong>,
              <strong>{data?.creditAccount?.[0]?.shortName}</strong>,
              moment(data?.recurring?.value?.startValue || new Date()).format(DATE_FORMAT)
            ]}
          />
        </p>
      </div>
    </Modal>
  );
}

ConfirmModalComponent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  modify: PropTypes.bool,
  submitDisabled: PropTypes.bool
};

ConfirmModalComponent.defaultProps = {
  submitDisabled: false,
  modify: false
};

export default ConfirmModalComponent;
